import { useQueryRefresh } from 'shared/apollo';
import { allUsers } from '../queries';

export function useAllUsers () {
  const { isLoading, refresh, data: query, error } = useQueryRefresh(allUsers);
  const data = query?.allUsers?.edges.map(({ node }) => ({...node})) ?? [];
  return { data, refresh, isLoading, error };
}
